import { apiRequest } from "../../index";

export const createSlot = async (slotData) => {
  return apiRequest("/api/owner/restaurant/slots", "POST", slotData, false);
};

export const updateSlot = async ({slotId, payload}) => {
  return apiRequest(`/api/owner/restaurant/slots/${slotId}`, "PUT", payload);
};

export const deleteSlot = async (slotId) => {
  return apiRequest(`/api/owner/restaurant/slots/${slotId}`, "DELETE");
};

export const getSlots = async (restaurantId) => {
  return apiRequest(`/api/owner/restaurant/slots/${restaurantId}`, "GET");
};
